<div class="viewer-wrapper">

  <!-- CLOSE BUTTON -->
  <button class="close-btn" (click)="close()">
    ✕
  </button>

  <!-- LEFT ARROW -->
  <button class="nav-btn left" (click)="prev()">
    ‹
  </button>

  <!-- IMAGE -->
  <div class="image-area">
    <img [src]="images[currentIndex]" />
  </div>

  <!-- RIGHT ARROW -->
  <button class="nav-btn right" (click)="next()">
    ›
  </button>

  <!-- INDICATORS -->
  <div class="dots">
    <span
      *ngFor="let img of images; let i = index"
      class="dot"
      [class.active]="i === currentIndex"
      (click)="goTo(i)"
    ></span>
  </div>

</div>


